module.exports = __webpack_public_path__ + "static/media/54_1138.f05f1e48.webp";